export default function () {
  return {
    livro: {},
  };
}
